// components/navigation.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SideNavigation, TopNavigation, BreadcrumbGroup, Button } from '@cloudscape-design/components';
import logo from '../images/amazon-web-services.png';

export const TopNav = ({ signOut, user }) => {
  const navigate = useNavigate();
  return (
    <TopNavigation
      identity={{
        href: '/',
        onFollow: (e) => {
          e.preventDefault();
          navigate('/');
        },
        title: 'MicroTransform',
        logo: {
          src: logo
        }
      }}
      
      utilities={[
        {
          type: "button",
          text: "Link",
          href: "https://example.com/",
          external: true,
          externalIconAriaLabel: " (opens in a new tab)"
        },
        {
          type: "button",
          iconName: "notification",
          title: "Notifications",
          ariaLabel: "Notifications (unread)",
          badge: true,
          disableUtilityCollapse: false
        },{
          type: "menu-dropdown",
          iconName: "settings",
          ariaLabel: "Settings",
          title: "Settings",
          items: [
            {
              id: "settings-org",
              text: "Organizational settings"
            },
            {
              id: "settings-project",
              text: "Project settings"
            }
          ]
        },

        {
          type: "menu-dropdown",
          text: "Customer Name",
          description: "email@example.com",
          iconName: "user-profile",
          items: [
            { id: "profile", text: "Profile" },
            { id: "preferences", text: "Preferences" },
            { id: "security", text: "Security" },
            {
              id: "support-group",
              text: "Support",
              items: [
                {
                  id: "documentation",
                  text: "Documentation",
                  href: "#",
                  external: true,
                  externalIconAriaLabel:
                    " (opens in new tab)"
                },
                { id: "support", text: "Support" },
                {
                  id: "feedback",
                  text: "Feedback",
                  href: "#",
                  external: true,
                  externalIconAriaLabel:
                    " (opens in new tab)"
                }
              ]
            },
            { id: "signout", text: "Sign out" }
          ],
          onItemClick: (e) => {
            if (e.detail.id === 'signout') {
              signOut();
            }
          }
        }
      ]}
    />
  );
};


export const Breadcrumbs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // This function converts the current path to breadcrumb items
  const getBreadcrumbItems = () => {
    const paths = location.pathname.split('/').filter(Boolean);
    return [
      { text: 'Home', href: '/', onClick: (e) => {
        e.preventDefault();
        navigate('/');
      }},
      ...paths.map((path, index) => ({
        text: path.charAt(0).toUpperCase() + path.slice(1),
        href: '/' + paths.slice(0, index + 1).join('/'),
        onClick: (e) => {
          e.preventDefault();
          navigate('/' + paths.slice(0, index + 1).join('/'));
        }
      }))
    ];
  };

  return <BreadcrumbGroup items={getBreadcrumbItems()} />;
};


export const SideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    // Add these new top-level items before the sections
    {
      type: 'link',
      text: 'Dashboard',
      href: '/dashboard',
      iconName: 'dashboard',
      onFollow: (e) => {
        e.preventDefault();
        navigate('/dashboard');
      }
    },
    {
      type: 'link',
      text: 'Jobs',
      href: '/jobs',
      iconName: 'status-in-progress',
      onFollow: (e) => {
        e.preventDefault();
        navigate('/jobs');
      }
    },
    {
      type: 'link',
      text: 'Reports',
      href: '/reports',
      iconName: 'file-content',
      onFollow: (e) => {
        e.preventDefault();
        navigate('/reports');
      }
    },
    {
      type: 'link',
      text: 'Create Project',
      href: '/create-project',
      iconName: 'file-content',
      onFollow: (e) => {
        e.preventDefault();
        navigate('/create-project');
      }
    },
    { type: 'divider' }, // Add a divider between top-level items and sections
    // Your existing sections...
    {
      type: 'section',
      text: 'Technical Analysis',
      items: [
        {
          type: 'link',
          text: 'Analysis Dashboards',
          href: '/technical-analysis',
          onFollow: (e) => {
            e.preventDefault();
            navigate('/technical-analysis');
          }
        }
      ]
    },
    {
      type: 'section',
      text: 'Domain Recommendation',
      items: [
        {
          type: 'link',
          text: 'Domain Dashboards',
          href: '/domain-analysis',
          iconName: 'search',
          onFollow: (e) => {
            e.preventDefault();
            navigate('/domain-analysis');
          }
        }
      ]
    },
    {
      type: 'section',
      text: 'MicroService Generation',
      items: [
        {
          type: 'link',
          text: 'Micro Services Dashboards',
          href: '/microservice-generation',
          iconName: 'chart-bar',
          onFollow: (e) => {
            e.preventDefault();
            navigate('/microservice-generation');
          }
        },
        /*{
          type: 'link',
          text: 'Component Comparison',
          href: '/componentcomparison',
          iconName: 'chart-bar',
          onFollow: (e) => {
            e.preventDefault();
            navigate('/componentcomparison');
          }
        }*/
      ]
    },
    { type: 'divider' },
    {
      type: 'section',
      text: 'Help & Resources',
      items: [
        {
          type: 'link',
          text: 'Documentation',
          href: 'https://w.amazon.com/bin/view/Main',
          iconName: 'file',
          external: true,
          target: '_blank',
          rel: 'noopener noreferrer'
        }
        
      ]
    }
  ];

  return (
    <SideNavigation
      activeHref={location.pathname}
      onFollow={event => {
        event.preventDefault();
        if (!event.detail.external) {
          navigate(event.detail.href);
        } else {
          window.open(event.detail.href, '_blank', 'noopener,noreferrer');
        }
      }}
      items={navigationItems}
    />
  );
};


